
import React, { useState, useEffect } from "react";
import { toast } from 'react-toastify';

import { useNavigate, useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { GET_STOCK_TRANSFER_LIST, APPROVE_STOCK_TRANSFER_REQUEST, GET_SPOT_BIDDING_REQ_LIST, APPROVE_SPOT_BIDDING_ALLOTMENT_REQ } from '../../../common/URLs';
import jwt from 'jwt-decode';
import { Container, Button, Box, Card, IconButton, Tooltip, Popover, Stack, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, Tab } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { PIT_ROLES, PROD } from "../../../common/constants";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Clear as CancelIcon, Done as ApproveIcon } from '@mui/icons-material';
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import { Send as SendIcon } from '@mui/icons-material';
import { ViewIcon } from "../../../common/icons";
import apiClient from "../../../axios";
import moment from "moment";

function SpotBiddingApproval() {

    const navigate = useNavigate();
    const decoded = jwt(getLocalStorageItem('id_token'));
    const { state } = useLocation();
    const [spotBiddingData, setSpotBiddingData] = useState();
    const [bulkApproveSpotBidding, setBulkApproveSpotBidding] = useState();
    const [spotBiddingList, setSpotBiddingList] = useState([]);
    const [tabValue, setTabValue] = useState(state?.tabVal ? state?.tabVal : "0");

    const [confirmOpen, setConfirmOpen] = useState(false);
    const handleConfirmOpen = () => setConfirmOpen(true);
    const handleConfirmClose = () => setConfirmOpen(false);

    const [confirmOpen2, setConfirmOpen2] = useState(false);
    const handleConfirmOpen2 = () => setConfirmOpen2(true);
    const handleConfirmClose2 = () => setConfirmOpen2(false);

    const onViewDetails = (row) => {
        console.log(row)
        navigate('/spotBiddingApproval/biddingDetails', {
            state: { selectedRow: row.row, tabVal: tabValue }
        });
    }


    useEffect(() => {
        getSpotBiddingRequestList();
    }, [tabValue]);

    const getSpotBiddingRequestList = (e) => {
        loaderService.showLoader();
        apiClient
            .post(GET_SPOT_BIDDING_REQ_LIST,
                {
                    // "stakeHolderUrn": "string",
                    "approvalStatus": tabValue,
                    // "isOrderGenerated": false,
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setSpotBiddingData(response.data.spotBiddingAllotmentRequestDetailsList);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const columns = [
        // { field: 'allotmentRequestNumber', headerName: 'Request Number', width: 180 },
        {
            field: 'bidNumber', headerName: 'Bid Number', width: 290,
        },
        { field: 'financialYear', headerName: 'Financial Year', width: 120 },
        { field: 'month', headerName: 'Month', width: 120 },
        {
            field: 'materialType', headerName: 'Material Type', width: 150,
            valueGetter: (params) => {
                if (params.row.materialType === "RawBamboo" || params.row.materialType === "rawbamboo") {
                    return "Raw Bamboo"
                } else if (params.row.materialType === "ChipBamboo" || params.row.materialType === "chipbamboo") {
                    return "Chip Bamboo"
                }
                else return ""

            }
        },
        { field: 'allotmentQuantity', headerName: 'Quantity(MT)', width: 140 },
        {
            field: 'biddingStartDate', headerName: 'Bidding Start Date', width: 150,
            valueGetter: (params) => {
                if (params.value !== null) {
                    return moment(params?.value).format("DD/MM/YYYY")
                } 
                else return "-"
            }
            // valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
        },
        {
            field: 'biddingEndDate', headerName: 'Bidding End Date', width: 150,
              valueGetter: (params) => {
                if (params.value !== null) {
                    return moment(params?.value).format("DD/MM/YYYY")
                } 
                else return "-"
            }
        },
        {
            field: 'biddingStartTime', headerName: 'Bidding Start Time', width: 150,
            valueFormatter: (params) => {
                const timeStr = params?.value;
                if (!timeStr || typeof timeStr !== 'string' || !timeStr.includes(':')) return '-';
                const [hour, minute] = timeStr.split(':');
                const h = parseInt(hour, 10);
                const ampm = h >= 12 ? 'PM' : 'AM';
                const formattedHour = h % 12 || 12;
                return `${formattedHour}:${minute} ${ampm}`;
            }
        },
        {
            field: 'biddingEndTime', headerName: 'Bidding End Time', width: 150,
            valueFormatter: (params) => {
                const timeStr = params?.value;
                if (!timeStr || typeof timeStr !== 'string' || !timeStr.includes(':')) return '-';
                const [hour, minute] = timeStr.split(':');
                const h = parseInt(hour, 10);
                const ampm = h >= 12 ? 'PM' : 'AM';
                const formattedHour = h % 12 || 12;
                return `${formattedHour}:${minute} ${ampm}`;
            }

        },
        { field: 'firstPartyType', headerName: "Source Type", width: 150 },
        { field: 'firstPartyUrn', headerName: "Source URN", width: 150 },
        { field: 'firstPartyName', headerName: "Source Name", width: 200 },
        { field: 'firstPartyLocationAddress', headerName: 'Source Address', width: 250 },
        { field: 'secondPartyType', headerName: "Destination Type", width: 150 },
        { field: 'secondPartyUrn', headerName: "Destination URN", width: 150 },
        { field: 'secondPartyName', headerName: "Destination Name", width: 150 },
        { field: 'secondPartyLocationAddress', headerName: 'Destination Address', width: 250 },
        {
            field: 'Action', width: 100,
            renderCell: (cellValues) => {
                return (
                    <Tooltip title="View">
                        <IconButton
                            variant="contained"
                            color="primary"
                            onClick={() => onViewDetails(cellValues)}
                        >
                            <ViewIcon />
                        </IconButton>
                    </Tooltip>
                );
            }
        },
    ];

    const onApprove = (e) => {
        toApproveBulk(true);
    }
    const onReject = (e) => {
        toApproveBulk(false);
    }

    const onConfirmApprove = (e) => {
        handleConfirmClose();
        onApprove(e);
    }

    const onApproveButtonClick = (e) => {
        handleConfirmOpen();
    }

    const onConfirmReject = (e) => {
        handleConfirmClose2();
        onReject(e);
    }

    const onRejectButtonClick = (e) => {
        handleConfirmOpen2();
    }

    const toApproveBulk = (approval) => {
        loaderService.showLoader();
        apiClient
            .post(APPROVE_SPOT_BIDDING_ALLOTMENT_REQ,
                {
                    "requestIdList":
                        spotBiddingList
                    ,
                    "isRequestApproved": approval,
                    "approvedBy": localStorage.getItem('InspectorEmail')
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setBulkApproveSpotBidding(response.data);
                getSpotBiddingRequestList();
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    useEffect(() => {
        if (bulkApproveSpotBidding) {
            if (bulkApproveSpotBidding.isSuccess === true) {
                toast.success(bulkApproveSpotBidding?.message)
            }
            else {
                toast.error(bulkApproveSpotBidding?.message ? bulkApproveSpotBidding?.message : "Error")
            }
        }
    }, [bulkApproveSpotBidding]);

    const handleTabChange = (e, newValue) => {
        e.preventDefault();
        setTabValue(newValue);
    }


    return (
        <>
            <Container maxWidth="xxl">
                <Stack direction={{ xs: 'column', sm: 'row' }} mb={1} justifyContent="space-between">
                    <Typography variant="h4" gutterBottom>
                        Spot Bidding Allotment Request
                    </Typography>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1}>
                        <Stack direction="row" spacing={1}>
                            <Button variant="contained" hidden={tabValue == '1' || tabValue === '2'} disabled={spotBiddingList?.length < 1} onClick={(e) => onApproveButtonClick(e)} startIcon={<ApproveIcon />}>
                                Approve
                            </Button>
                            {/* <Button variant="contained" hidden={tabValue == '1' || tabValue === '2'} disabled={spotBiddingList?.length < 1} onClick={(e) => onRejectButtonClick(e)} startIcon={<CancelIcon />}>
                                Reject
                            </Button> */}
                        </Stack>
                    </Stack>
                </Stack>
                <Card>
                    <TabContext value={tabValue}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: "whitesmoke" }}>
                            <TabList onChange={handleTabChange} >
                                <Tab label="Spot Bidding Allotment Request Pending List" value="0" />
                                <Tab label="Spot Bidding Allotment Request Approved List" value="1" />
                            </TabList>
                        </Box>
                        <TabPanel value="0">
                            <Box style={{ height: 450, width: '100%' }}>
                                {
                                    spotBiddingData &&
                                    <DataGrid
                                        getRowHeight={() => 'auto'}
                                        rows={spotBiddingData}
                                        columns={columns}
                                        pageSize={10}
                                        checkboxSelection
                                        components={{ Toolbar: QuickSearchToolbar }}
                                        onSelectionModelChange={(newSelection) => {
                                            setSpotBiddingList(newSelection.map(row => {
                                                let Ids = ""
                                                spotBiddingData.forEach(item => {
                                                    if (row === item.id) {
                                                        Ids = item.id;
                                                    }
                                                })
                                                return Ids;
                                            }));
                                        }}
                                    />
                                }
                            </Box>
                        </TabPanel>
                        <TabPanel value="1">
                            <Box style={{ height: 450, width: '100%' }}>
                                {
                                    spotBiddingData &&
                                    <DataGrid
                                        getRowHeight={() => 'auto'}
                                        rows={spotBiddingData}
                                        columns={columns}
                                        pageSize={10}
                                        components={{ Toolbar: QuickSearchToolbar }}

                                    />
                                }
                            </Box>
                        </TabPanel>
                    </TabContext>
                </Card>
            </Container>
            <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmApprove} onClose={handleConfirmClose} action="Approve Spot Bidding Allotment Request" />
            <ConfirmationPopover onOpen={confirmOpen2} onConfirm={onConfirmReject} onClose={handleConfirmClose2} action="Reject Spot Bidding Allotment Request" />
        </>
    );
}
export default SpotBiddingApproval;
